import { FixedBlockType } from '../types/block-type';
import { addNewBlock } from '../utils/add-new-block';
import { TimeUnit, timeUnitTranslate } from '../utils/translates';
function addLoopBlock(color_of_run_blocks, scenario_name) {
    const block = {
        message0: '%1 %2 Выполнять каждые %3 %4 %5 %6',
        args0: [
            {
                type: 'field_input',
                name: 'scenario_name',
                text: scenario_name,
            },
            {
                type: 'input_dummy',
            },
            {
                type: 'field_number',
                name: 'value',
                value: 0,
                min: 0,
            },
            {
                type: 'field_dropdown',
                name: 'unit_time',
                options: [
                    [timeUnitTranslate[TimeUnit.SEC], TimeUnit.SEC.toString()],
                    [timeUnitTranslate[TimeUnit.MIN], TimeUnit.MIN.toString()],
                    [timeUnitTranslate[TimeUnit.HOUR], TimeUnit.HOUR.toString()],
                    [timeUnitTranslate[TimeUnit.DAY], TimeUnit.DAY.toString()],
                ],
            },
            {
                type: 'input_dummy',
            },
            {
                type: 'input_statement',
                name: 'statement',
            },
        ],
        colour: color_of_run_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.loop, block);
    return FixedBlockType.loop;
}
function addScheduleRunBlock(color_of_run_blocks, scenario_name) {
    const block = {
        message0: '%1 %2 ' +
            '🕔 Выполнять по расписанию %3 ' +
            '%4Пн\u2800%5Вт\u2800%6Ср\u2800%7Чт \u2800 %8Пт \u2800 %9Сб \u2800 %10Вс %11' +
            'в %12 : %13 %14 %15',
        args0: [
            {
                type: 'field_input',
                name: 'scenario_name',
                text: scenario_name,
            },
            {
                type: 'input_dummy',
            },
            {
                type: 'input_dummy',
            },
            {
                type: 'field_checkbox',
                name: 'Mo',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'Tu',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'We',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'Th',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'Fr',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'Sa',
                checked: true,
            },
            {
                type: 'field_checkbox',
                name: 'Su',
                checked: true,
            },
            {
                type: 'input_dummy',
            },
            {
                type: 'field_number',
                name: 'hour',
                value: 0,
                min: 0,
                max: 23,
            },
            {
                type: 'field_number',
                name: 'min',
                value: 0,
                min: 0,
                max: 59,
            },
            {
                type: 'input_dummy',
            },
            {
                type: 'input_statement',
                name: 'statement',
            },
        ],
        colour: color_of_run_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.schedule_run, block);
    return FixedBlockType.schedule_run;
}
function addIfRunBlock(color_of_run_blocks, scenario_name) {
    const block = {
        message0: ' %1 %2 ' + 'Когда сработает: %3 ' + 'То %4',
        args0: [
            {
                type: 'field_input',
                name: 'scenario_name',
                text: scenario_name,
            },
            {
                type: 'input_dummy',
            },
            {
                type: 'input_value',
                name: 'comparator',
                check: 'Boolean',
            },
            {
                type: 'input_statement',
                name: 'statement',
            },
        ],
        colour: color_of_run_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.if_run, block);
    return FixedBlockType.if_run;
}
function addLinearRunBlock(color_of_run_blocks, scenario_name) {
    const block = {
        message0: '%1 %2 %3',
        args0: [
            {
                type: 'field_input',
                name: 'scenario_name',
                text: scenario_name,
            },
            {
                type: 'input_dummy',
            },
            {
                type: 'input_statement',
                name: 'statement',
            },
        ],
        colour: color_of_run_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.linear, block);
    return FixedBlockType.linear;
}
export function generateRunBlocks(color_of_run_blocks, config, current_scenario) {
    return [addLinearRunBlock, addIfRunBlock, addScheduleRunBlock, addLoopBlock].map((func) => func(color_of_run_blocks, current_scenario.name));
}
